import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { OrderDetailsPage } from '@/components/OrderDetailsPage';
import { SuperAdminOnly } from '@/components/SuperAdminOnly';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/r/$restaurantId/orders/$orderId')({
  component: Component,
});

function Component() {
  const { orderId } = Route.useParams();

  const { data: orderWrap, isError, isPending, error } = useQuery(api.orders.getById, { orderId });

  if (isPending) return <LoadingIcon />;
  if (isError) {
    return (
      <>
        <div>Error loading order.</div>
        <SuperAdminOnly>
          <div>{error.message}</div>
        </SuperAdminOnly>
      </>
    );
  }
  if (orderWrap === null) return <div>Order not found</div>;

  return (
    <div className="p-6 min-h-[calc(100vh-(--spacing(16)))] flex-1 flex-col gap-4 bg-muted/60 dark:bg-muted/20 space-y-6">
      <OrderDetailsPage orderWrap={orderWrap} />
    </div>
  );
}
